export const COOKIE_NAME = process.env.REACT_APP_COOKIE_NAME || '';

export const HEADER_NAME = process.env.REACT_APP_HEADER_NAME || '';
